module.exports = __webpack_public_path__ + "static/media/unorderedList.492fb4ef.svg";